// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Auth pages (login, signup, forgot/reset password) — new menu palette.
 * Matches src/assets/scss/_new-theme-overrides.scss (\$new-theme-primary #1F2937).
 * Requires \`eb-new-theme\` on <html> (see src/lib/applyAuthNewTheme.ts).
 */
html.eb-new-theme {
  --eb-auth-primary: #1f2937;
  --eb-auth-primary-hover: #111827;
  --eb-auth-accent-light: #f0f0f0;
  --eb-auth-accent-light-hover: #e5e5e5;
  --eb-auth-outline-border: #e5e5e5;
  --eb-auth-link: #377dff;
  --eb-auth-link-hover: #2f6ad9;
}

html.eb-new-theme,
html.eb-new-theme body {
  color: var(--eb-auth-primary);
}

/* Buttons: theme text colors only (!important beats base \`a { color: #377dff }\`) */
html.eb-new-theme .btn-primary,
html.eb-new-theme a.btn-primary,
html.eb-new-theme .btn-primary:hover,
html.eb-new-theme .btn-primary:focus,
html.eb-new-theme a.btn-primary:hover,
html.eb-new-theme a.btn-primary:focus {
  color: #fff !important;
  background-color: var(--eb-auth-primary);
  border-color: var(--eb-auth-primary);
}

html.eb-new-theme .btn-primary:hover,
html.eb-new-theme .btn-primary:focus,
html.eb-new-theme a.btn-primary:hover,
html.eb-new-theme a.btn-primary:focus {
  background-color: var(--eb-auth-primary-hover);
  border-color: var(--eb-auth-primary-hover);
}

html.eb-new-theme .btn.btn-active-primary,
html.eb-new-theme a.btn.btn-active-primary {
  color: var(--eb-auth-primary) !important;
  background-color: var(--eb-auth-accent-light);
}

html.eb-new-theme .btn.btn-active-primary:hover:not(.btn-active),
html.eb-new-theme a.btn.btn-active-primary:hover:not(.btn-active) {
  color: #fff !important;
  border-color: var(--eb-auth-primary);
  background-color: var(--eb-auth-primary);
}

/* OAuth / btn-light (G Suite, Microsoft, Shopify) — light bg, subtle darker hover */
html.eb-new-theme .btn.btn-light,
html.eb-new-theme a.btn.btn-light,
html.eb-new-theme .google-btn,
html.eb-new-theme a.google-btn {
  color: var(--eb-auth-primary) !important;
  background-color: var(--eb-auth-accent-light) !important;
  border-color: var(--eb-auth-accent-light) !important;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

html.eb-new-theme .btn.btn-light:hover,
html.eb-new-theme .btn.btn-light:focus,
html.eb-new-theme a.btn.btn-light:hover,
html.eb-new-theme a.btn.btn-light:focus,
html.eb-new-theme .google-btn:hover,
html.eb-new-theme .google-btn:focus,
html.eb-new-theme a.google-btn:hover,
html.eb-new-theme a.google-btn:focus {
  color: var(--eb-auth-primary) !important;
  background-color: var(--eb-auth-accent-light-hover) !important;
  border-color: var(--eb-auth-accent-light-hover) !important;
}

html.eb-new-theme .btn.btn-outline-light,
html.eb-new-theme button.btn.btn-outline-light,
html.eb-new-theme a.btn.btn-outline-light {
  color: var(--eb-auth-primary) !important;
  background-color: #f5f5f5 !important;
  border-color: var(--eb-auth-outline-border) !important;
}

html.eb-new-theme .btn.btn-outline-light:hover,
html.eb-new-theme .btn.btn-outline-light:focus,
html.eb-new-theme .btn.btn-outline-light:active,
html.eb-new-theme button.btn.btn-outline-light:hover,
html.eb-new-theme button.btn.btn-outline-light:focus,
html.eb-new-theme a.btn.btn-outline-light:hover,
html.eb-new-theme a.btn.btn-outline-light:focus {
  color: var(--eb-auth-primary) !important;
  background-color: #ffffff !important;
  border-color: var(--eb-auth-outline-border) !important;
  box-shadow: none !important;
}

/* Plain text links (not .btn) stay brand blue */
html.eb-new-theme a:not(.btn):not(.pwd-field-icon-underline) {
  color: var(--eb-auth-link) !important;
}

html.eb-new-theme a:not(.btn):not(.pwd-field-icon-underline):hover {
  color: var(--eb-auth-link-hover) !important;
}

html.eb-new-theme .form-control:focus {
  border-color: var(--eb-auth-primary);
  box-shadow: none;
}

html.eb-new-theme .form-select:focus {
  border-color: var(--eb-auth-primary);
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/login-new-theme.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,qCAAqC;EACrC,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA,mFAAmF;AACnF;;;;;;EAME,sBAAsB;EACtB,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;;;;EAIE,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;;EAEE,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA,oFAAoF;AACpF;;;;EAIE,wCAAwC;EACxC,wDAAwD;EACxD,oDAAoD;EACpD,8EAA8E;AAChF;;AAEA;;;;;;;;EAQE,wCAAwC;EACxC,8DAA8D;EAC9D,0DAA0D;AAC5D;;AAEA;;;EAGE,wCAAwC;EACxC,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;;;;;;;EAOE,wCAAwC;EACxC,oCAAoC;EACpC,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA,gDAAgD;AAChD;EACE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB","sourcesContent":["/**\n * Auth pages (login, signup, forgot/reset password) — new menu palette.\n * Matches src/assets/scss/_new-theme-overrides.scss ($new-theme-primary #1F2937).\n * Requires `eb-new-theme` on <html> (see src/lib/applyAuthNewTheme.ts).\n */\nhtml.eb-new-theme {\n  --eb-auth-primary: #1f2937;\n  --eb-auth-primary-hover: #111827;\n  --eb-auth-accent-light: #f0f0f0;\n  --eb-auth-accent-light-hover: #e5e5e5;\n  --eb-auth-outline-border: #e5e5e5;\n  --eb-auth-link: #377dff;\n  --eb-auth-link-hover: #2f6ad9;\n}\n\nhtml.eb-new-theme,\nhtml.eb-new-theme body {\n  color: var(--eb-auth-primary);\n}\n\n/* Buttons: theme text colors only (!important beats base `a { color: #377dff }`) */\nhtml.eb-new-theme .btn-primary,\nhtml.eb-new-theme a.btn-primary,\nhtml.eb-new-theme .btn-primary:hover,\nhtml.eb-new-theme .btn-primary:focus,\nhtml.eb-new-theme a.btn-primary:hover,\nhtml.eb-new-theme a.btn-primary:focus {\n  color: #fff !important;\n  background-color: var(--eb-auth-primary);\n  border-color: var(--eb-auth-primary);\n}\n\nhtml.eb-new-theme .btn-primary:hover,\nhtml.eb-new-theme .btn-primary:focus,\nhtml.eb-new-theme a.btn-primary:hover,\nhtml.eb-new-theme a.btn-primary:focus {\n  background-color: var(--eb-auth-primary-hover);\n  border-color: var(--eb-auth-primary-hover);\n}\n\nhtml.eb-new-theme .btn.btn-active-primary,\nhtml.eb-new-theme a.btn.btn-active-primary {\n  color: var(--eb-auth-primary) !important;\n  background-color: var(--eb-auth-accent-light);\n}\n\nhtml.eb-new-theme .btn.btn-active-primary:hover:not(.btn-active),\nhtml.eb-new-theme a.btn.btn-active-primary:hover:not(.btn-active) {\n  color: #fff !important;\n  border-color: var(--eb-auth-primary);\n  background-color: var(--eb-auth-primary);\n}\n\n/* OAuth / btn-light (G Suite, Microsoft, Shopify) — light bg, subtle darker hover */\nhtml.eb-new-theme .btn.btn-light,\nhtml.eb-new-theme a.btn.btn-light,\nhtml.eb-new-theme .google-btn,\nhtml.eb-new-theme a.google-btn {\n  color: var(--eb-auth-primary) !important;\n  background-color: var(--eb-auth-accent-light) !important;\n  border-color: var(--eb-auth-accent-light) !important;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n\nhtml.eb-new-theme .btn.btn-light:hover,\nhtml.eb-new-theme .btn.btn-light:focus,\nhtml.eb-new-theme a.btn.btn-light:hover,\nhtml.eb-new-theme a.btn.btn-light:focus,\nhtml.eb-new-theme .google-btn:hover,\nhtml.eb-new-theme .google-btn:focus,\nhtml.eb-new-theme a.google-btn:hover,\nhtml.eb-new-theme a.google-btn:focus {\n  color: var(--eb-auth-primary) !important;\n  background-color: var(--eb-auth-accent-light-hover) !important;\n  border-color: var(--eb-auth-accent-light-hover) !important;\n}\n\nhtml.eb-new-theme .btn.btn-outline-light,\nhtml.eb-new-theme button.btn.btn-outline-light,\nhtml.eb-new-theme a.btn.btn-outline-light {\n  color: var(--eb-auth-primary) !important;\n  background-color: #f5f5f5 !important;\n  border-color: var(--eb-auth-outline-border) !important;\n}\n\nhtml.eb-new-theme .btn.btn-outline-light:hover,\nhtml.eb-new-theme .btn.btn-outline-light:focus,\nhtml.eb-new-theme .btn.btn-outline-light:active,\nhtml.eb-new-theme button.btn.btn-outline-light:hover,\nhtml.eb-new-theme button.btn.btn-outline-light:focus,\nhtml.eb-new-theme a.btn.btn-outline-light:hover,\nhtml.eb-new-theme a.btn.btn-outline-light:focus {\n  color: var(--eb-auth-primary) !important;\n  background-color: #ffffff !important;\n  border-color: var(--eb-auth-outline-border) !important;\n  box-shadow: none !important;\n}\n\n/* Plain text links (not .btn) stay brand blue */\nhtml.eb-new-theme a:not(.btn):not(.pwd-field-icon-underline) {\n  color: var(--eb-auth-link) !important;\n}\n\nhtml.eb-new-theme a:not(.btn):not(.pwd-field-icon-underline):hover {\n  color: var(--eb-auth-link-hover) !important;\n}\n\nhtml.eb-new-theme .form-control:focus {\n  border-color: var(--eb-auth-primary);\n  box-shadow: none;\n}\n\nhtml.eb-new-theme .form-select:focus {\n  border-color: var(--eb-auth-primary);\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
